<template>
  <div class="carAdd">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title"
          >新增采购车辆</template
        >
      </QS-h3-title>
      <!-- 来源信息 -->
      <QS-h4-title title="来源信息" />
      <form-text-box
        :dataList="dataList"
        :model="originOrderInfoDefaultValue"
        :column="3"
      >
      </form-text-box>
      <!-- 车辆选择 -->
      <addVehicle
        ref="AddVehicle"
        :carTotalNum="carTotalNum"
        :purchaseOrderId="purchaseOrderId"
        :deptId="Number(originOrderInfoDefaultValue.deptId)"
      />
      <!-- 采购信息 -->
      <purchaDate @updateDate="updateDateFn" />
      <!-- 支付计划设置 -->
      <!-- receiveOrPayFlag 属性控制支付计划组件中的所有 收(false) 改为 付(true) -->
      <PaymentPlanSetup
        ref="PaymentPlanSetup"
        :tableDataFrom="tableDataFrom"
        :startStopDate="dateInfo.startStopDate"
        :receiveOrPayFlag="true"
      />
      <template slot="bottomAction">
        <el-button size="mini" @click="cancelFn">取消</el-button>
        <el-button
          :loading="submitLoading"
          size="mini"
          :disabled="!enabledSubmit"
          @click="submitFn"
          type="primary"
          >确认</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
import addVehicle from '../components/addVehicle.vue'
import purchaDate from '../components/purchaDate.vue'
import PaymentPlanSetup from '@/pages/orders/components/PaymentPlanSetup.vue'
// eslint-disable-next-line import/no-cycle
import { purchaseSubAddSignCheck } from '@/api/domain/purchase.js'

export default {
  components: {
    addVehicle,
    purchaDate,
    PaymentPlanSetup,
  },
  name: 'CarAdd',
  data() {
    return {
      purchaseOrderId: '', // 采购订单ID
      providerId: '', // 车源方/服务商ID
      // 来源信息-label
      dataList: [
        {
          el: 'text',
          itemConfig: {
            label: '服务商名称',
            prop: 'customerName',
          },
        },
        {
          el: 'text',
          itemConfig: {
            label: '服务商类型',
            prop: 'customerType',
          },
        },
        {
          el: 'text',
          itemConfig: {
            label: '采购方式',
            prop: 'purchaseModeName',
          },
        },
      ],
      // 来源信息-value
      originOrderInfoDefaultValue: {
        customerName: '', // 服务商名称
        customerType: '车源方', // 服务商类型
        purchaseModeName: '', // 采购方式
        payName: '',
        deptId: '',
      },
      // 支付计划
      tableDataFrom: {
        tableData: [],
      },
      dateInfo: {
        signDate: '', // 签署日期
        startStopDate: [], // 起止日期
        startDate: '', // 计租开始日期
        endDate: '', // 计租结束日期
      },
      carTotalNum: 0, // 应收车辆总台数
      paymentPlanTableValid: false, // 支付计划校验判断boolean，true为表单通过校验，false为未通过
      submitLoading: false,
    }
  },
  mounted() {
    // 初始化来源信息
    this.initOriginInfoFun()
  },
  watch: {
    // 监听支付计划中的表单，动态变更【确认】按钮的可点击状态
    'tableDataFrom.tableData': {
      handler(val) {
        if (!val || !val.length) {
          this.paymentPlanTableValid = false
        } else {
          // 只要支付款项中有一个item的信息未填完整，就代表表单校验未通过
          this.paymentPlanTableValid = !val.some(
            (item) => item.complete === false,
          )
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    enabledSubmit() {
      return (
        this.paymentPlanTableValid && // 支付计划设置表单校验值
        this.$refs.AddVehicle.addVehicleTable.length > 0 && // 添加车辆list
        this.dateInfo.signDate && // 签署日期
        this.dateInfo.startStopDate.length > 0
      ) // 付款起止日期
    },
  },
  methods: {
    initOriginInfoFun() {
      const { mixInfo } = this.$route.query || {}
      let mixInfoObj = {}
      try {
        mixInfoObj = JSON.parse(mixInfo)
      } catch (e) {
        console.log(e)
      }
      Object.keys(mixInfoObj).forEach((item) => {
        for (const key in this.originOrderInfoDefaultValue) {
          if (item === key) {
            this.originOrderInfoDefaultValue[key] = mixInfoObj[item]
          }
        }
      })
      // this.$refs.originInfo.initParams()
      this.carTotalNum = mixInfoObj.carTotalNum || 0
      this.providerId = mixInfoObj.providerId // 车源方/服务商ID
      this.purchaseOrderId = mixInfoObj.id // 采购订单ID
      // 支付计划中的开始和结束日期复制
      const ff = !(mixInfoObj.contractStartDate.length > 10)
      this.$set(this.dateInfo, 'startStopDate', [
        `${mixInfoObj.contractStartDate}${ff ? ' 00:00:00' : ''}`,
        `${mixInfoObj.contractEndDate}${ff ? ' 23:59:59' : ''}`,
      ])
      this.$set(
        this.dateInfo,
        'startDate',
        `${mixInfoObj.contractStartDate}${ff ? ' 00:00:00' : ''}`,
      )
      this.$set(
        this.dateInfo,
        'endDate',
        `${mixInfoObj.contractEndDate}${ff ? ' 23:59:59' : ''}`,
      )
    },
    // 取消
    cancelFn() {
      this.$refreshBack(false)
    },
    // 提交数据
    async submitFn() {
      try {
        await this.$refs.PaymentPlanSetup.formValidate()
      } catch (e) {
        return
      }
      // this.submitLoading = true
      // 获取添加的车辆信息
      const carList = this.$refs.AddVehicle.addVehicleTable
      carList.forEach((item) => {
        item.modelId = Number(item.modelId)
      })
      const postData = {
        purchaseOrderId: this.purchaseOrderId, // 采购订单ID
        providerId: this.providerId, // 车源方/服务商ID
        carList, // 添加的车辆list
        ...this.dateInfo, // 采购信息（签署日期和收款起止日）
        orderAccruedPlans: this.tableDataFrom.tableData, // 支付计划
      }
      const { code } = await purchaseSubAddSignCheck(postData)
      this.submitLoading = false
      if (code === 1) {
        this.$message.success('采购车辆添加成功')
        this.$refreshBack(true)
        this.$router.push('/purchaseNew/purchaseOrder/list')
      }
    },
    // 签署日期和付款起止日变更
    updateDateFn(val) {
      this.dateInfo = val
      // 重新计算周期
      this.$refs?.PaymentPlanSetup?.FormCalculation()
    },
  },
}
</script>
